import * as React from 'react'
import Parser from 'ua-parser-js'
import { getDefaultKeyBinding, KeyBindingUtil } from 'draft-js'
const { isCtrlKeyCommand, hasCommandModifier } = KeyBindingUtil

const a_BUTTON = 65
const d_BUTTON = 68
const r_BUTTON = 82
const t_BUTTON = 84

const parser = new Parser()
const os = parser.getOS()

export default (e: React.KeyboardEvent<{}>) => {
  if (e.keyCode === d_BUTTON && isCtrlKeyCommand(e)) return 'do-task'
  else if (e.keyCode === r_BUTTON && isCtrlKeyCommand(e)) return 'dont-do-task'
  else if (e.keyCode === t_BUTTON && isCtrlKeyCommand(e)) return 'timeout-task'
  else if (os.name === 'Mac OS' && e.keyCode === a_BUTTON && hasCommandModifier(e)) return 'select-all'
  else if (e.keyCode === a_BUTTON && isCtrlKeyCommand(e)) return 'select-all'
  else return getDefaultKeyBinding(e)
}



// WEBPACK FOOTER //
// ./src/components/RemarksApplicationRoot/keyBindings.ts